import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdOutlineRule, MdPrint, MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import ModuleTabChooser from "../ReusableComponents/ModuleTabChooser";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import ModalRedacao from './ModalRedacao';
import Redacoes from '../Redacoes/Redacoes';
import Provas from '../Provas/Provas';
import CandidatosVinculados from '../CandidatosVinculados/CandidatosVinculados';
import FiscaisVinculados from '../FiscaisVinculados/FiscaisVinculados';
import CorretoresVinculados from '../CorretoresVinculados/CorretoresVinculados';
import SalasProcesso from '../SalasProcesso/SalasProcesso';
import TextosApoio from './TextosApoio';
import ResultadosRedacao from './ResultadosRedacao';
import RedacaoIA from './RedacaoIA'; // Importe o novo componente

class ShowRedacoesProcesso extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: true,
      roles: [],
      name: '',
      caminho: '',
      termos: '',
      loading_save: false,
      msgErro: '',
      loading_image: false,
      processo: {},
      redacao: {},
      show_more: false,

      activeTab: -1
    };

  }


  get_redacao_processo(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_redacao_processo/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_redacao_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({
            loading_screen: false, redacao: resp.redacao, processo: resp.redacao.processo
          });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }






  componentDidMount() {
    let tab = new URLSearchParams(this.props.location.search).get('tab');
    if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });else
    if (tab === null) this.setState({ activeTab: -1 });
    this.get_redacao_processo(this.props.match.params.id);
  }







  render() {
    if (this.state.loading_screen) return <SkeletonCoursePage />;else
    return (
      <div style={{ position: "relative" }}>
                <div className="card">
                    <div className="card-body">
                        <div style={{ float: 'right' }}>
                            <DefaultButton
                bg="secondary"
                text={this.context.t("back")}
                icon={<RiArrowGoBackLine />}
                search={'?tab=0'}
                to={`/processos/show/${this.state.processo.id}`} />

                        </div>
                        <div className="flex jcsb">
                            <h4 className="header">{this.state.redacao.name}</h4>
                        </div>
                        <p className="page-subtitle">{this.context.t("description_show_essay_page")}</p>


                        <p className="ver_regras" onClick={() => {
              this.setState({ show_more: true });
            }} style={{ marginRight: "2px" }}> <b style={{ float: "left", marginRight: 2, color: 'var(--app-text)' }}>{this.context.t("label_statement")}: </b> <MdOutlineRule /> {this.context.t("legacy_ver_enunciado")} </p>

                        <p style={{ marginRight: "2px" }}><a className="ver_regras" target='_blank' href={URL + 'api/faculdade/download_redacao_template/' + this.state.redacao.id + '?token=' + this.props.token} style={{ float: "left", marginRight: "2px" }}> <b style={{ marginRight: "2px", marginRight: 2 }}>{this.context.t("ui_imprimir_template_da_redacao_42731392")}</b> <MdPrint /> </a></p>
                        <ModalRedacao showModal={this.state.show_more} setShowModal={(e) => this.setState({ show_more: e })} redacao_name={this.state.redacao.name} regras={this.state.redacao.enunciado} />

                        {/* <div style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre',height:this.state.show_more==false?100:'fit-content',overflowY:this.state.show_more==false? 'hidden':'visible' }}>
              <b style={{ float: "left", marginRight: "2px" }}>{'Regras:'} </b>
              <br/>
              <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: this.state.processo.regras }}>
              </div>
              </div> */}
                        {/* <div className="w100 flex align-center fdcolumn margin-bottom">
              <div className="course-banner" style={{
              backgroundImage: `url(${STORAGE_URL+ this.state.faculdade.logo})`,
              backgroundSize: "contain",
              backgroundRepeat:'no-repeat',
              backgroundPositionX:'center',
              width: "100%",
              height: "200px",
              borderRadius: "7px"
              }} />
              </div> */}
                        <br />
                        <br />

                        <ModuleTabChooser
              activeTab={this.state.activeTab}
              modules={[
              { id: 0, title: this.context.t("legacy_textos_de_apoio"), description: this.context.t("legacy_gerencie_os_textos_de_apoio_da_redacao") },
              this.state.redacao?.processo?.online == true && { id: 1, title: this.context.t("settings_results"), description: this.context.t("legacy_acompanhe_os_resultados_desta_redacao") },
              this.props.user?.empresa?.plan?.essay_ia == true && { id: 2, title: this.context.t("legacy_corrigir_com_ia"), description: this.context.t("legacy_acesse_a_correcao_assistida_por_ia") }]
              }
              onSelect={(value) => {
                this.setState({ activeTab: value });
                this.props.history.push({ search: `?tab=${value}` });
              }}
              onBack={() => {
                this.setState({ activeTab: -1 });
                this.props.history.push({ search: '' });
              }} />

                        <TabPanel value={this.state.activeTab} index={0} padding={0}>
                            <h5 className="tab-section-title">{this.context.t("legacy_textos_de_apoio")}</h5>
                            <TextosApoio redacao_name={this.state.redacao.name} textos={this.state.redacao.textos_apoio} />

                        </TabPanel>
                        {this.state.redacao?.processo?.online == true && <TabPanel value={this.state.activeTab} index={1} padding={0}>
                            <h5 className="tab-section-title">{this.context.t("settings_results")}</h5>
                            {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                            <ResultadosRedacao processo_name={this.state.processo.name} processo_id={this.state.processo.id} redacao_name={this.state.redacao.name} redacao_id={this.state.redacao.id} />

                        </TabPanel>}
                        {this.props.user?.empresa?.plan?.essay_ia == true && <TabPanel value={this.state.activeTab} index={2} padding={0}>
                            <h5 className="tab-section-title">{this.context.t("legacy_corrigir_com_ia")}</h5>
                            <RedacaoIA
                processo_name={this.state.processo.name}
                processo_id={this.state.processo.id}
                redacao_name={this.state.redacao.name}
                redacao_id={this.state.redacao.id} />

                        </TabPanel>}

                    </div>
                </div>

            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  token: state.AppReducer.token,
  user: state.AppReducer.user
});


const SkeletonCoursePage = () => {
  return (
    <div className="card">
            <div className="card-body">
                <div className="skeleton-title" />
                {/* <div className="skeleton-small-text skeleton-shimmer"/>
          <div className="skeleton-small-text skeleton-shimmer"/> */}
                <br />
                <div className="w100 flex jcc align-center">
                    <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
                </div>
                <br />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
                <div className="skeleton-small-button skeleton-shimmer" />
            </div>
        </div>);

};

export default connect(mapsStateToProps, { logout })(ShowRedacoesProcesso);
